import { animated } from '#app/components/Primitives/Animated.js';
import { type IconSvgProps, InfoIcon } from '@contra/icons/icons';
import { useIsomorphicLayoutEffect } from '@contra/react-hooks/useIsomorphicLayoutEffect';
import { createElement } from 'react';
import { css, styled } from 'styled-components';

const ValidationContainer = styled(animated.div)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 12px 12px 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    line-height: 1.5;
    background-color: ${theme.colorsV2.black};
    color: ${theme.colorsV2.white};
    pointer-events: none;
    width: 100%;
    transition:
      transform 300ms ease,
      opacity 300ms ease;

    ${theme.mediaQueries.sm} {
      position: absolute;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border-top: none;
      border: 1px solid ${theme.colorsV2.white};
    }
  `}
`;

export const DialogSelectValidationItem = ({
  icon = InfoIcon,
  isOpen,
  label,
  onClose,
}: {
  readonly icon?: (props: IconSvgProps) => JSX.Element;
  readonly isOpen: boolean;
  readonly label: string;
  readonly onClose: () => void;
}) => {
  useIsomorphicLayoutEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        onClose();
      }, 1_200);
    }
  }, [isOpen, onClose]);

  return (
    <ValidationContainer
      animate={
        isOpen
          ? { opacity: 1, transform: 'translateY(0)' }
          : { opacity: 0, transform: 'translateY(16px)' }
      }
      initial={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {createElement(icon, { size: 16 })} {label}
    </ValidationContainer>
  );
};
